import * as React from "react";

const Gear = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="svg1"
    width="24"
    height="24"
    version="1.1"
    viewBox="0 0 6.35 6.35"
  >
    <g
      id="g51"
      fill="none"
      stroke="#000"
      strokeDasharray="none"
      strokeOpacity="1"
      strokeWidth="0.4"
    >
      <circle
        id="circle51"
        cx="3.175"
        cy="3.175"
        r="1.058"
        fillOpacity="1"
        strokeDashoffset="22.224"
        strokeLinecap="round"
        strokeLinejoin="miter"
        display="inline"
        opacity="1"
      ></circle>
      <path
        id="path1"
        d="M2.627.629A.07.07 0 0 0 2.555.7v.434a.2.2 0 0 1-.127.187 2 2 0 0 0-.479.278.2.2 0 0 1-.226.015l-.377-.217a.07.07 0 0 0-.053-.005.07.07 0 0 0-.045.03l-.549.952a.07.07 0 0 0 .028.098l.375.216a.2.2 0 0 1 .1.204 2 2 0 0 0-.018.277q0 .145.017.277a.2.2 0 0 1-.1.203l-.374.217a.08.08 0 0 0-.034.045.07.07 0 0 0 .006.053l.549.951a.08.08 0 0 0 .045.033.07.07 0 0 0 .053-.006l.377-.218a.2.2 0 0 1 .226.015q.22.173.479.28a.2.2 0 0 1 .127.187v.434c0 .04.03.07.072.07h1.098c.042 0 .07-.028.07-.07v-.434a.2.2 0 0 1 .127-.187c.172-.07.333-.166.478-.28a.2.2 0 0 1 .227-.015l.377.218q.025.014.055.006a.07.07 0 0 0 .043-.033l.548-.951a.07.07 0 0 0 .006-.053.08.08 0 0 0-.033-.045l-.375-.217a.2.2 0 0 1-.1-.203 2 2 0 0 0 0-.554.2.2 0 0 1 .1-.204l.375-.216a.07.07 0 0 0 .027-.098l-.548-.951a.07.07 0 0 0-.043-.031.07.07 0 0 0-.055.005l-.377.217A.2.2 0 0 1 4.4 1.6a2 2 0 0 0-.478-.278.2.2 0 0 1-.127-.187V.7c0-.042-.03-.072-.07-.072z"
        transform="matrix(1.0578 0 0 1.0578 -.183 -.183)"
      ></path>
    </g>
  </svg>
);

export default Gear;
